'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propsForStory = exports.propsForModel = exports.propsForView = undefined;

require('core-js/modules/es.number.constructor.js');

var _transformProps2 = require('@didi/webx-ui-utils/src/transform-props');

var _transformProps3 = _interopRequireDefault(_transformProps2);

function _interopRequireDefault(obj) {
    try {
        return obj && obj.__esModule ? obj : { default: obj };
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_interopRequireDefault@@../../../../src/model/props.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}

var props = {
  /* 编辑器 */
  pageConfig: {
    type: Object,
    value: {
      /* 发券设置 */
      canvas_id: '',
      auto_receive: true,

      /* 页面设置 */
      activity_title: '',
      background_image: 'https://dpubstatic.udache.com/static/dpubimg/5xQ1hP8hkw/bg.png',
      background_color: '#fe6b02',
      cover_title: '滴滴大礼包',
      hotline: '4000000999',
      hotline_color: '#ffffff',
      cover_logo: 'https://dpubstatic.udache.com/static/dpubimg/faf5e663-686b-4495-9e50-9996f923686e.png',
      activity_rules: '\u89C4\u5219\u5982\u4E0B:\n1. \u6D3B\u52A8\u622A\u6B62\u65E5\u671Fxxxx\u5E74xx\u6708xx\u65E5\u3002\n2. \u6D3B\u52A8\u671F\u95F4\u540C\u4E00\u7528\u6237\u4EC5\u53EF\u9886\u53D6\u4E00\u6B21\u3002\n3. \u9886\u53D6\u6210\u529F\u540E\u53EF\u5728\u201C\u6EF4\u6EF4\u51FA\u884Capp-\u94B1\u5305-\u5238\u201D\u91CC\u67E5\u770B\u3002',

      /* 领取成功页面设置 */
      result_button_type: 'share',
      result_button_miniprogram_type: 'didi',
      result_button_text: '分享好友来领券',
      move_type: 'normal',
      result_button_detailed_android_download: '',
      result_button_detailed_h5_link: '',
      result_button_detailed_ios_download: '',
      result_button_detailed_miniprogram_link: '',
      auto_jump: true,

      /* 领取失败页面设置 */
      error_button_type: 'share',
      error_button_miniprogram_type: 'didi',
      error_button_text: '领更多优惠',
      error_move_type: 'normal',
      error_button_detailed_android_download: '',
      error_button_detailed_h5_link: '',
      error_button_detailed_ios_download: '',
      error_button_detailed_miniprogram_link: ''
    }
  },

  /* 业务 */
  couponCollection: {
    type: Object,
    value: {
      coupon: [{
        type: 3,
        display_name: '滴滴抵扣券',
        // 券名称
        batch_id: 18284,
        activity_id: 148348,
        product_id: 430,
        amount: 1000,
        end_time: '2022-12-31 23:59:59',
        // 结束时间 新版使用
        remark: ''
      }, {
        type: 100,
        display_name: '滴滴折扣券',
        // 券名称
        batch_id: 18284,
        activity_id: 148348,
        product_id: 430,
        discount: 80,
        max_amount: 1000,
        end_time: '2022-12-31 23:59:59',
        // 结束时间 新版使用
        remark: ''
      }],
      business_coupon: [{
        display_name: '单球香草甜筒兑换',
        // 券名称
        coupon_id: 20471,
        // 券包ID
        icon: 'https://img-hxy021.didistatic.com/static/gsh5actimg/1775/c84vmkqbu42ov7tsb4dg.jpeg',
        // 券图标
        coupon_type: 1,
        // 1 - 代金券，2 - 折扣券  5 - 门槛券
        merchant_id: 67297,
        // 商家ID
        merchant_name: '滴滴商户券——生态拓展',
        // 商家名称
        price_value: 5,
        // 代金券金额(元)
        min_use_price: 5.01,
        // 代金券门槛价(元)
        is_valid: 1,
        // 1 老版 2 新版
        // expire_day: 3, // 老版使用
        begin_time: '2022-04-25 00:00:00',
        // 开始时间 新版使用
        end_time: '2022-12-31 23:59:59' // 结束时间 新版使用

      }]
    }
  },
  activityInfo: {
    type: Object,
    value: {
      lose_time: 12390,
      real_stock: 1317,
      stock: 1500,
      activity_rules: '活动规则活动规则活动规则活动规则活动规则活动规则活动规则活动规则活动规则活动规则'
    }
  },
  posterUrl: {
    type: String,
    value: ''
  },
  isH5: {
    type: Boolean,
    value: false
  },
  isHide: {
    type: Boolean,
    value: false
  },
  loading: {
    type: Boolean,
    value: false
  },
  pageStatus: {
    type: Number,
    value: 1
  },
  showRuleModal: {
    type: Boolean,
    value: false
  },
  bigRedEnvelope: {
    type: Boolean,
    value: true
  },
  virtualKeyboardEnv: {
    type: String,
    value: 'CN'
  },
  showLoadingModal: {
    type: Boolean,
    value: false
  },
  autoReceive: {
    type: Boolean,
    value: false
  }
};

var _transformProps = (0, _transformProps3.default)(props),
    propsForView = _transformProps.propsForView,
    propsForModel = _transformProps.propsForModel,
    propsForStory = _transformProps.propsForStory;

exports.propsForView = propsForView;
exports.propsForModel = propsForModel;
exports.propsForStory = propsForStory;